import React from "react";
import DocumentWhite from "../icons/document-white.svg";
import DocumentGrey from "../icons/document-grey.svg";

const DocumentReviewStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? DocumentWhite : DocumentGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Document Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};

export default DocumentReviewStepIcon;
